import { Editor, Transforms } from 'slate';

export const withParagraph = (editor: Editor) => {
  const { normalizeNode } = editor;

  editor.normalizeNode = (entry) => {
    // Ensure editor always has at least one paragraph
    if (editor.children.length === 0) {
      Transforms.insertNodes(editor, {
        type: 'paragraph',
        children: [
          {
            text: '',
          },
        ],
      });
      return;
    }

    normalizeNode(entry);
  };

  return editor;
};
